import firebase from "firebase";
import FirebaseModel, { FirebaseModelData } from "@/models/FirebaseModel";
import ProcessoModel, { ProcessoUsuariosRef } from "@/models/Processo";
import _debug from "debug";

const debug = _debug("Mediacao:models:Solicitacao.ts");

export interface SolicitacaoDados extends FirebaseModelData, ProcessoUsuariosRef {
    id?: string;
    titulo: string;
    status: string;
    resumo: string;
}

export default class SolicitacaoModel extends FirebaseModel {
    public static async fetchById(id: string): Promise<SolicitacaoModel> {
        const ref = firebase
            .firestore()
            .collection("solicitacoes")
            .doc(id);

        const solicitacao = await ref.get();
        if (solicitacao.exists) {
            return this.fromQuerySnapshot(solicitacao);
        } else {
            throw new Error(`Solicitação não econtrada!(id:${id})`);
        }
    }

    public get titulo(): string {
        return this.myData.titulo;
    }
    public set titulo(titulo: string) {
        this.myData.titulo = titulo;
    }

    public get status() {
        return this.myData.status;
    }

    public set status(theNewStatus: string) {
        this.myData.status = theNewStatus;
    }

    public get id(): string | undefined {
        return this.myData.id;
    }
    public set id(id: string | undefined) {
        this.myData.id = id;
    }

    public get resumo() {
        return this.myData.resumo;
    }

    public set resumo(resumo: string) {
        this.myData.resumo = resumo;
    }

    public static async listByUser(userId: string): Promise<SolicitacaoModel[]> {
        debug("SolicitacaoModel.listByUser: userId=" + userId);
        return new Promise((resolve, reject) => {
            const solicitacoes: SolicitacaoModel[] = [];
            const collection = firebase.firestore().collection("solicitacoes");
            collection
                .where(
                    "userParteUm",
                    "==",
                    firebase
                        .firestore()
                        .collection("users")
                        .doc(userId),
                )
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        solicitacoes.push(this.fromQuerySnapshot(doc, userId));
                    });
                    resolve(solicitacoes);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    private static fromQuerySnapshot(doc: firebase.firestore.DocumentSnapshot, userId?: string) {
        const dados: unknown = Object.assign({ id: doc.id }, doc.data());
        return new SolicitacaoModel(ProcessoModel.fromRef2String(dados) as SolicitacaoDados, userId);
    }
    public userId?: string;

    protected myData: SolicitacaoDados;

    constructor(dados?: SolicitacaoDados, userId?: string) {
        super("solicitacoes", userId);
        this.userId = userId;
        if (!dados) {
            this.myData = {
                id: undefined,
                titulo: "",
                status: "aberta",
                resumo: "",
            };
        } else {
            this.myData = dados;
        }
    }

    public async add(dados: SolicitacaoDados = this.myData, userRef: ProcessoUsuariosRef): Promise<SolicitacaoModel> {
        debug("tentando adicionar solicitacao", dados);
        const solicitacaoRef = this.getRef(dados);
        const solicitacao = await solicitacaoRef.get();
        if (solicitacao.exists) {
            throw new Error("Essa Solicitação já existe");
        } else {
            const dadosParaSalvar: any = Object.assign({}, dados, userRef);
            delete dadosParaSalvar.id;
            if (typeof dadosParaSalvar.userParteUm === "string") {
                dadosParaSalvar.userParteUm = firebase
                    .firestore()
                    .collection("users")
                    .doc(dadosParaSalvar.userParteUm);
            }
            const dadosSalvos = await super._add(dadosParaSalvar);
            const result = new SolicitacaoModel(ProcessoModel.fromRef2String(dadosSalvos) as SolicitacaoDados);
            return result;
        }
    }

    public async save() {
        return super.update(this.myData);
    }

    private getRef(dados?: SolicitacaoDados): firebase.firestore.DocumentReference {
        let ref = firebase
            .firestore()
            .collection("solicitacoes")
            .doc();
        if (dados && dados.id) {
            ref = firebase
                .firestore()
                .collection("solicitacoes")
                .doc(dados.id);
        }
        return ref;
    }
}
